import { BaseEntity } from "./base.entity.js";

export abstract class AggregateRoot extends BaseEntity {}
